import { render } from "./ConfirmRequest.vue?vue&type=template&id=202a9e78&scoped=true"
import script from "./ConfirmRequest.vue?vue&type=script&lang=js"
export * from "./ConfirmRequest.vue?vue&type=script&lang=js"

import "./ConfirmRequest.vue?vue&type=style&index=0&id=202a9e78&lang=scss&scoped=true"
import "./ConfirmRequest.vue?vue&type=style&index=1&id=202a9e78&lang=scss"

import exportComponent from "/Users/a/Desktop/app/boyuan_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-202a9e78"]])

export default __exports__